import { createContext, useContext } from 'react';
import { UserStore } from './UserStore';

export const userStore = new UserStore();
export const UserContext = createContext(userStore);
export const useUserStore = () => useContext(UserContext);
